export function getSalesQuoteProgressPercent(quote) {
  if (quote?.fulfillment_percent != null && !Number.isNaN(Number(quote.fulfillment_percent))) {
    return Math.min(100, Math.max(0, Math.round(Number(quote.fulfillment_percent))));
  }
  if (!quote?.items?.length) return 0;

  const totalQuantity = quote.items.reduce(
    (sum, item) => sum + parseFloat(item.quantity || 0),
    0,
  );
  const usedQuantity = quote.items.reduce((sum, item) => {
    const qty = parseFloat(item.quantity || 0);
    const fulfilled = parseFloat(item.fulfilled_quantity || 0);
    const pending =
      item.pending_quantity !== undefined ? parseFloat(item.pending_quantity || 0) : Math.max(0, qty - fulfilled);
    return sum + Math.max(0, qty - pending);
  }, 0);

  return totalQuantity > 0 ? Math.round((usedQuantity / totalQuantity) * 100) : 0;
}

export function getSalesQuoteFulfillmentLabel(quote) {
  if (!quote) return { label: '—', className: 'bg-gray-100 text-gray-700' };
  const percent = getSalesQuoteProgressPercent(quote);
  if (quote.status === 'cancelled') {
    return { label: 'Cancelada', className: 'bg-red-100 text-red-800' };
  }
  if (percent >= 100 || quote.fulfillment_status === 'completed') {
    return { label: 'Completada', className: 'bg-blue-100 text-blue-800' };
  }
  if (percent > 0 || quote.fulfillment_status === 'partial') {
    return { label: 'Parcial', className: 'bg-amber-100 text-amber-800' };
  }
  return { label: 'Emitida', className: 'bg-green-100 text-green-800' };
}
